import Card from "components/card";
import React, { useEffect, useState, useCallback } from "react";
import ApiKeysDataTable from "./components/ApiKeysDataTable";
import Loader from "components/Loader";
import { apiKeysApi } from "api/models";
import { ApiKey } from "api/models";
import { handleAxiosAndCaughtError } from "utils";
import { useAuthContext } from "auth/AuthProvider";

const ApiKeys = () => {
  const [apiKeys, setApiKeys] = useState<ApiKey[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { user } = useAuthContext(); // Assuming you have access to current workspace

  const fetchApiKeys = useCallback(async (signal?: AbortSignal) => {
    setLoading(true);
    setError(null);
    try {
      // Use workspace-specific endpoint
      if (user?.current_workspace?.id) {
        const resp = await apiKeysApi.getAll(user.current_workspace.id);
        setApiKeys(resp.api_keys);
      } else {
        setApiKeys([]);
      }
    } catch (err: any) {
      if (signal?.aborted || err.name === "CanceledError") {
        return; // Aborted
      }
      setError("Click here to retry");
      handleAxiosAndCaughtError(err);
    } finally {
      setLoading(false);
    }
  }, [user?.current_workspace?.id]);

  useEffect(() => {
    const abortController = new AbortController();
    fetchApiKeys(abortController.signal);
    return () => abortController.abort();
  }, [fetchApiKeys]);

  return (
    <Card extra="relative w-full h-[80vh] md:mt-3 mt-12 px-6">
      {loading ? (
        <Loader
          txt="Loading API keys..."
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ) : error ? (
        <div
          className="absolute left-1/2 top-1/2 flex -translate-x-1/2
        -translate-y-1/2 flex-col items-center justify-center py-10
         "
        >
          <span className="mb-4 text-red-500">{error}</span>
          <button
            className="rounded bg-brand-500 px-4 py-2 text-white transition hover:bg-brand-600"
            onClick={() => fetchApiKeys()}
          >
            Retry
          </button>
        </div>
      ) : (
        <ApiKeysDataTable 
          fetchApiKeys={fetchApiKeys} 
          tableData={apiKeys || []} 
          workspaceId={user?.current_workspace?.id}
        />
      )}
    </Card>
  );
};

export default ApiKeys; 